const dev = {
  // baseURL: 'http://localhost:8080',
  baseURL: 'http://api.map.e12e.com',
  mapServerBaseURL: 'http://localhost:8000/api/v1',
  amap: {
    jsKey: '2e90e2958b369b27ab6b108e59cfed9f',
    webserviceKey: '4f0a6ee93edb9406fb4d6182d6bd03a1',
    webserviceKeyPersonal: '2f2d7a90f58b47d8f1e1f754029368e1',
  },
};

const prod = {
  baseURL: '//api.map.e12e.com',
  // baseURL: "http://localhost:8080",
  mapServerBaseURL: 'https://map.service.conobug.com/api/v1',
  amap: {
    jsKey: '2e90e2958b369b27ab6b108e59cfed9f',
    webserviceKey: '3f0a6ee93edb9406fb4d6182d6bd03a1',
    webserviceKeyPersonal: '1f2d7a90f58b47d8f1e1f754029368e1',
  },
};

const actual = process.env.NODE_ENV === 'development' ? dev : prod;

export default actual;
